<template>
  <v-dialog v-if="isModalActive" :value="isModalActive" max-width="820" @input="inputModal">
    <v-card
      id="orders-buttons-modal"
      class="pa-0 pb-1 ma-0"
      :color="$vuetify.theme.dark ? 'dark_backgroundDarkBlue' : undefined"
    >
      <v-card-title>
        {{ $t('views.common.ordersButtonsModal.title') }}
      </v-card-title>
      <v-card-text class="ma-0 pt-3 pb-4 px-5">
        <v-row class="ma-0 pa-0">
          <v-col
            v-for="item in items"
            :key="`${item.value}-${item.subvalue}`"
            cols="12"
            md="3"
            sm="6"
            xs="6"
            class="my-0 py-1 mx-0 px-1"
          >
            <v-card
              class="button-card ma-1 pa-3 elevation-0"
              @click="buttonClicked(item.value, item.subvalue)"
            >
              <div class="items-flex justify-center">
                <div>
                  <v-icon :size="item.size || 30" class="mr-3 button-icon" :color="item.color">
                    {{ item.icon }}
                  </v-icon>
                </div>
                <div>
                  <v-icon v-if="item.new" :size="22" class="ml-2 button-new-icon" color="primary">
                    mdi-new-box
                  </v-icon>
                </div>
              </div>

              <div class="mt-2">
                <span class="button-title">{{ item.title }}</span>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="mt-0 pb-3 pa-0">
        <v-spacer />
        <v-btn class="mr-7" text :small="$vuetify.breakpoint.smAndDown" @click="closeModal">
          {{ $t('views.common.ordersButtonsModal.cancel') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { ORDERS_TYPE_PALETTE } from '@/lib/colors.js'
import modalMixin from '@/views/components/core/modalMixin.js'

export default {
  mixins: [modalMixin],
  computed: {
    // ...mapState(['user']),
    // isMd() {
    //   return this.$vuetify.breakpoint.smAndDown
    // },
    isMobile() {
      return this.$vuetify.breakpoint.xs
    },
    items() {
      return [
        {
          value: 'sharePremium',
          title: this.$t('views.common.addButtons.sharePremium'),
          icon: 'mdi-handshake-outline',
          color: ORDERS_TYPE_PALETTE.sharePremium,
        },
        {
          value: 'capitalIncrease',
          title: this.$t('views.common.addButtons.capitalIncrease'),
          icon: 'mdi-briefcase-upload-outline',
          color: ORDERS_TYPE_PALETTE.capitalIncrease,
        },
        {
          value: 'scrip',
          title: this.$t('views.common.addButtons.scrip'),
          icon: 'mdi-piggy-bank-outline',
          color: ORDERS_TYPE_PALETTE.scrip,
        },
        {
          value: 'stakeReward',
          title: this.$t('views.common.addButtons.stakeReward'),
          icon: 'mdi-hand-coin-outline',
          color: ORDERS_TYPE_PALETTE.stakeReward,
        },
        {
          value: 'drip',
          title: this.$t('views.common.addButtons.drip'),
          icon: 'mdi-chart-box-plus-outline',
          color: ORDERS_TYPE_PALETTE.drip,
        },
        {
          value: 'bonus',
          title: this.$t('views.common.addButtons.bonus'),
          icon: 'mdi-gift-outline',
          color: ORDERS_TYPE_PALETTE.bonus,
          size: 29,
        },
        {
          value: 'brokerTransfer',
          title: this.$t('views.common.addButtons.brokerTransfer'),
          icon: 'mdi-bank-transfer',
          color: ORDERS_TYPE_PALETTE.brokerTransfer,
          size: 33,
        },
        {
          value: 'split',
          title: this.$t('views.common.addButtons.split'),
          icon: 'mdi-call-split',
          color: ORDERS_TYPE_PALETTE.split,
        },
        {
          value: 'commission',
          title: this.$t('views.common.addButtons.commission'),
          icon: 'mdi-bank-remove',
          color: ORDERS_TYPE_PALETTE.commission,
        },
        {
          value: 'paidInterest',
          title: this.$t('views.common.addButtons.paidInterest'),
          icon: 'mdi-bank-minus',
          color: ORDERS_TYPE_PALETTE.paidInterest,
        },
        {
          value: 'spinOff',
          title: this.$t('views.common.addButtons.spinOff'),
          icon: 'mdi-set-split',
          color: ORDERS_TYPE_PALETTE.spinOff,
          size: 35,
        },
        {
          value: 'interestRetention',
          title: this.$t('views.common.addButtons.interestRetention'),
          icon: 'mdi-home-remove-outline',
          color: ORDERS_TYPE_PALETTE.interestRetention,
        },
      ]
    },
  },
  methods: {
    resetForm() {
      // nothing to do
    },
    buttonClicked(value, subvalue) {
      this.closeModal()
      this.$emit('selected', value, subvalue)
    },
  },
}
</script>

<style lang="scss">
#orders-buttons-modal {
  // text-align: center;
  .items-flex {
    display: flex;
    &.justify-center {
      justify-content: flex-end;
    }
    &.justify-between {
      justify-content: space-between;
    }
  }

  .button-card {
    line-height: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    text-align: center;
    cursor: pointer;
    background-color: white;
    border: 1px solid #eeeeee;
    &:hover {
      background-color: #f7f8fb;
      border: 1px solid #999;
    }
    min-height: 100px !important;
    .button-title {
      font-size: 13px;
      font-weight: 300;
    }
  }

  &.theme--dark {
    .button-card {
      background-color: #323940;
      border: 1px solid #5b5b5b;
      &:hover {
        background-color: #3b444c;
        border: 1px solid #a5a5a5;
      }
    }
  }
}
</style>
